import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";

import { useTranslation } from "react-i18next";

function TableRegionPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/table-regions";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [tableRegionName, setTableRegionName] = useState("");
  const [tableRegionColor, setTableRegionColor] = useState("#28c76f");
  const [tableRegionOrder, setTableRegionOrder] = useState(0);
  const [tableRegionDeleted, setTableRegionDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  }

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/table-regions/${id}`)
      .then((tableRegion) => {
        fillFields(tableRegion);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const tableRegion = {
      name: tableRegionName,
      color: tableRegionColor ? tableRegionColor : "ffffff",
      order: tableRegionOrder ? tableRegionOrder : 0,
      storeId: storeId,
      deleted: tableRegionDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/table-regions/${id}`, tableRegion)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.tableRegionSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/table-regions", tableRegion)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.tableRegionCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (tableRegion) => {
    setTableRegionName(tableRegion.name);
    setTableRegionColor(tableRegion.color);
    setTableRegionOrder(tableRegion.order);
    setTableRegionDeleted(tableRegion.deleted);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editRegion") : t("pages.titles.createRegion")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>{t("common.labels.name")}</label>
                        <Form.Control
                          placeholder={t("common.labels.name")}
                          required={true}
                          type="text"
                          value={tableRegionName}
                          onChange={(event) => setTableRegionName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={tableRegionColor}
                          onChange={(event) => setTableRegionColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={tableRegionOrder}
                          onChange={(event) => setTableRegionOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-2"
                            checked={tableRegionDeleted}
                            onChange={(e) => setTableRegionDeleted(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TableRegionPage;
